import React, { useEffect, useState } from 'react';
import { navLinks, LOGO } from '../mock';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [active, setActive] = useState('overview');

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 40);
      const y = window.scrollY + 220;
      navLinks.forEach((l) => {
        const el = document.getElementById(l.href.slice(1));
        if (el && el.offsetTop <= y && el.offsetTop + el.offsetHeight > y) setActive(l.href.slice(1));
      });
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50"
      style={{
        transition: 'all 0.35s ease',
        backdropFilter: scrolled ? 'blur(18px)' : 'none',
        background: scrolled ? 'rgba(15, 31, 34, 0.85)' : 'transparent',
        borderBottom: scrolled ? '1px solid rgba(79, 191, 184, 0.18)' : '1px solid transparent',
      }}
    >
      <div className="container-x flex items-center justify-between" style={{ height: 84 }}>
        <a href="#overview" className="flex items-center gap-3" style={{ textDecoration: 'none' }}>
          <img src={LOGO} alt="Vistora" className="logo-img" style={{ width: 46, height: 46, borderRadius: 8, background: 'var(--warm-white)', padding: 3 }} />
          <div className="hidden md:block">
            <div className="font-display" style={{ fontSize: 22, letterSpacing: '0.14em', color: 'var(--paper)', fontWeight: 700, lineHeight: 1 }}>
              VISTORA
            </div>
            <div className="font-mono" style={{ fontSize: 8, color: 'var(--teal-light)', letterSpacing: '0.28em', marginTop: 4 }}>
              CRAFTING VISUAL IMPACT
            </div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {navLinks.map((l) => (
            <a key={l.href} href={l.href} className={`nav-link ${active === l.href.slice(1) ? 'active' : ''}`}>
              <span className="num">{l.num}</span>{l.label}
            </a>
          ))}
        </nav>

        <a href="#contact" className="btn-primary" style={{ textDecoration: 'none', padding: '12px 22px', fontSize: 12 }}>
          Start a Project
        </a>
      </div>
    </header>
  );
}
